import React from 'react'

// SelectF 
// overstyle - override default tpc style
// foptions - override default tpc options
// opdisable - determine if "נא לבחור" is disables, default is no

//export const randomID = (id) => id +'-'+ Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
export const randomID = (id) => id // no random

export const SelectF = props => {
    let tpc = props.tpc
    let tp = props.tp
    let lstyle = props.overstyle === undefined ? tpc.style : props.overstyle
    let foptions = props.foptions === undefined ? tpc.options : props.foptions 
    return (
        <select style={lstyle} name={tpc.name} data-id={randomID(tpc.id)} value={tpc.value} onChange={tp.onProductTableUpdate} > 
            {tpc.disable !== undefined && tpc.value === tpc.disable // disable all 
              ? <option key={1111111} value="נא לבחור" disabled={true} > נא לבחור </option>
              : props.opdisable === undefined ? <option key={1111111} value="נא לבחור" > נא לבחור </option>
              : props.opdisable ? <option key={1111111} value="נא לבחור" disabled> נא לבחור </option>
              : <option key={1111111} value="נא לבחור"> נא לבחור </option>}
            {//console.log("tpc.option", showOptions(tpc.name) )
                foptions.map(item => {
                    if (tpc.disable !== undefined && (tpc.value === tpc.disable || item === tpc.disable))
                        return <option key={item} value={item} disabled={true}>{item}</option>
                    return <option key={item} value={item}>{item}</option>
                })
            }
        </select>
    )
}
export const TextareaF = props => {
    let tpc = props.tpc
    let tp = props.tp
    let lstyle = props.overstyle === undefined ? tpc.style : props.overstyle
    if (tpc.edit)
      return <textarea style={lstyle} name={tpc.name} data-id={randomID(tpc.id)} 
                    value={tpc.value} onChange={tp.onProductTableUpdate} />
    return  <textarea style={lstyle} name={tpc.name} data-id={randomID(tpc.id)} value={tpc.value} />
}
export const InputF = props => {
      let tpc = props.tpc
      let tp = props.tp
      if (tpc.edit)
        return  <input style={tpc.style} type={tpc.type} name={tpc.name}  data-id={randomID(tpc.id)}
                    placeholder= {tpc.placeholder === undefined ? "" : tpc.placeholder} 
                    value={tpc.value} onChange={tp.onProductTableUpdate}    />
      return (
                <input style={tpc.style} type={tpc.type} name={tpc.name}  data-id={randomID(tpc.id)}
                    placeholder= {tpc.placeholder === undefined ? "" : tpc.placeholder}
                    value={tpc.value} onChange={tp.onProductTableUpdate} disabled
                    />
      )
  }